<ui-split-view pageType="statement-of-account" class="bg-gray-50">
	<div leftPanel>
		<ui-content-header title="Statement of Account" type="page">
		</ui-content-header>

		<div class="grid grid-cols-2 gap-4 mt-4">
			<ui-section title="General" class="col-span-2">
				<ui-button
					actions
					label="Restore Default Values"
					[style]="'ghost'"
					size="sm"
					(click)="reset()"
					[loading]="resetting$ | async"
					preset="MEDIUM_EMPHASIS"
				></ui-button>
				<div section-content class="flex flex-col gap-2">
					<p *ngIf="isAccountingEnabled" title-action>
						<app-anchor
							[icon]="ICON.EXTERNAL"
							type="static"
							[url]="accountingUrl"
							>View Accounting Export</app-anchor
						>
					</p>
					<div class="flex gap-3 items-center">
						<app-checkbox
							class="flex-auto"
							type="clear"
							[ngModel]="useInclusivePrice"
							(ngModelChange)="setUseInclusivePrice($event)"
							>Calculate fee based on all-inclusive price</app-checkbox
						>
						<div
							class="w-48"
							[ngClass]="{
								'opacity-50 pointer-events-none cursor-not-allowed':
									!useInclusivePrice,
							}"
						>
							<app-input
								[@openClose]
								label="All-inclusive price"
								type="cents"
								[startIcon]="ICON.DOLLAR"
								[ngModel]="allInclusivePrice"
								(debounce)="setAllInclusivePrice($event)"
							></app-input>
						</div>
					</div>
				</div>
			</ui-section>

			<ng-container *ngIf="totals$ | async as t">
				<div
					*ngIf="t.allInclusiveTotalInbalance"
					class="col-span-2 border border-red rounded-xl p-4 flex gap-4 items-start"
				>
					<app-icon [icon]="ICON.WARNING" class="text-red"></app-icon>
					<p class="p-sm">
						The Statement totals {{ t.total | centsToDollars }} due to rounding.
						Please modify a Non HST Disbursement by
						{{ t.allInclusiveTotalInbalance | centsToDollars }}.
					</p>
				</div>
			</ng-container>

			<app-statement-of-account-table
				class="col-span-2"
				(addStatement)="addStatement(statementTypes.FEE)"
				(editStatementText)="editStatementText($event)"
				[hst]="hst"
				[statements]="statementsFee"
				[statementType]="statementTypes.FEE"
				title="Legal fees"
				[totals]="totals"
			></app-statement-of-account-table>

			<div
				class="col-span-2 grid-cols-[repeat(auto-fit,minmax(500px,1fr))] grid gap-x-2 gap-y-4"
			>
				<app-statement-of-account-table
					(addStatement)="addStatement(statementTypes.HST)"
					(editStatementText)="editStatementText($event)"
					[hst]="hst"
					[statements]="statementsHst"
					[statementType]="statementTypes.HST"
					title="HST disbursements"
					[totals]="totals"
					[tabIndexStart]="statementsFee?.length"
				></app-statement-of-account-table>

				<app-statement-of-account-table
					(addStatement)="addStatement(statementTypes.NON_HST)"
					(editStatementText)="editStatementText($event)"
					[hst]="hst"
					[statements]="statementsNonHst"
					[statementType]="statementTypes.NON_HST"
					title="Non HST disbursements"
					[totals]="totals"
					[tabIndexStart]="statementsFee?.length + statementsHst?.length"
				></app-statement-of-account-table>
			</div>

			<ui-section title="Grand total" class="col-span-2">
				<div actions>
					<span class="text-lg font-semibold">{{
						totals?.total | centsToDollars
					}}</span>
				</div>
				<div section-content class="flex flex-col gap-2">
					<div class="flex justify-between gap-2">
						<p class="p">Received on account</p>
						<div class="flex flex-col items-end">
							<app-input
								#recievedInput
								type="cents"
								[startIcon]="ICON.DOLLAR"
								textAlign="right"
								[(ngModel)]="totals.receivedOnAccount"
								(debounce)="updateReceived($event || 0)"
								class="flex-1"
							></app-input>
							<span
								btn="link"
								(click)="soa?.received !== null && updateReceived(null)"
								class="text-sm underline"
								[ngClass]="{
									'text-green cursor-pointer': soa?.received !== null,
									'opacity-50 text-gray-500 cursor-not-allowed':
										soa?.received === null,
								}"
								>Set to grand total</span
							>
						</div>
					</div>
					<div class="flex justify-between">
						<span class="p">Balance owing</span>
						<span class="p">{{ totals?.owing | centsToDollars }}</span>
					</div>
				</div>
			</ui-section>
		</div>
	</div>
	<div rightPanel>
		<ng-container
			*ngIf="statementOfAccountDocSourceIdByMatterType$ | async as sourceId"
		>
			<app-documents-word-matter-viewer
				*ngIf="!(useHtmlDocuments$ | async)"
				sourceId="{{ sourceId }}"
			></app-documents-word-matter-viewer>
		</ng-container>

		<div class="grid min-h-0" *ngIf="useHtmlDocuments$ | async">
			<app-document-matter-viewtor
				class="h-full"
				sourceId="soac"
			></app-document-matter-viewtor>
		</div>
	</div>
</ui-split-view>
